import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { AdminService } from '../../services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DepData, RoleData, SectionData, SignUpModel } from '../../interfaces/auth/auth.model';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { DirectionService } from '../../services/direction.service';
import { PaginatorComponent } from '../../shared/paginator/paginator.component';
import { IPaginator } from '../../components/strategic-project/strategic-project.component';
import { TooltipModule } from 'primeng/tooltip';
import { NavTitlePipe } from '../../pipes/nav-title.pipe';


@Component({
  selector: 'app-permissions',
  standalone: true,
  imports: [
    ButtonModule,
    IconFieldModule,
    RadioButtonModule,
    ConfirmPopupModule,
    InputTextModule,
    InputIconModule,
    FormsModule,
    DropdownModule,
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    TableModule,
    PaginatorComponent,
    TooltipModule,
    NavTitlePipe,
  ],
  templateUrl: './permissions.component.html',
  styleUrl: './permissions.component.scss',
  providers: [ConfirmationService],
})
export class PermissionsComponent implements OnInit {

  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  users = [] as SignUpModel[];
  filteredUsers = [] as SignUpModel[];
  selectedUser = {} as SignUpModel;
  selectedPermission = ''
  searchTerm = '';
  activeMenuId: number | null = null;
  isModalVisible = false;
  isModalSubmitted = false
  isPasswordModalVisible = false;
  selectedUserPasswordId = 0;

  deps_Sections = [] as SectionData[];
  roles = [] as RoleData[]
  roleOptions = [] as { label: string, value: string }[];
  selectedDepId = 0;
  isDeleteUserModal = false;
  departments = [] as DepData[]
  Sec_Dep_Disabled = false;
  currentUserDeletionPreview = {} as any
  UserProjects = [] as any[]
  isProjectDeletable = false
  today!: Date;
  userProjectsForm!: FormGroup;
  userIndicatorForm!: FormGroup;
  UserIndicators = [] as any[]
  passwordFieldType: string = 'password';
  passwordIconClass: string = 'fa fa-eye-slash';
  dir!: 'rtl' | 'ltr';
  selectedUserId = 0;
  displayType = 'cards'; // Add display type toggle
  get password_control(): AbstractControl {
    return this.passwordForm.get('password') as AbstractControl
  }

  userForm = new FormGroup({
    role: new FormControl('', Validators.required),
    name: new FormControl('', Validators.required),
    username: new FormControl('', Validators.required),
    email: new FormControl(''),
    password: new FormControl('', [Validators.minLength(6)]),
    job_title: new FormControl('', Validators.required),
    department_id: new FormControl('', Validators.required),
    section_id: new FormControl('', Validators.required),
  });

  passwordForm = new FormGroup({
    password: new FormControl('', Validators.required),
  })

  constructor(
    private confirmationService: ConfirmationService,
    private adminService: AdminService,
    private toastr: ToastrService,
    private authService: AuthService,
    private directionService: DirectionService

  ) {
  }
  ngOnInit(): void {
    this.today = new Date();


    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })

    this.fetchUsers();


    this.authService.GetUserRelations().subscribe((response: any) => {
      const { roles, departments } = response['data'];
      this.roles = roles as RoleData[];
      this.departments = departments as DepData[];
      
      // Initialize role options for dropdown
      this.roleOptions = [
        { label: this.dir === 'rtl' ? 'الكل' : 'All', value: 'all' },
        ...this.roles.map(role => ({
          label: this.dir === 'rtl' ? role.name_ar : role.name_en,
          value: role.name_en
        }))
      ];
      
      // Set default selection
      if (!this.selectedPermission) {
        this.selectedPermission = 'all';
      }
    })

  }
  private fetchUsers() {
    this.authService.ListPaginatedUsers({
      page: this.pageNumber, page_size: this.page_size, filters: this.selectedPermission
    }).subscribe((response: any) => {
      this.users = response['data']['users'];
      this.filteredUsers = response['data']['users'];
      this.paginator = response['data']['pagination'] as IPaginator;
      this.onSearch();
    });
  }

  onSearch() {
    const term = (this.searchTerm || '').trim().toLowerCase();
    if (!term) {
      this.filteredUsers = this.users;
      return;
    }
    this.filteredUsers = this.users.filter((user: any) =>
      [user.name, user.username, user.email, user.job_title, user.depData?.name, user.sectionData?.name]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .includes(term)
    );
  }

  clearSearch() {
    this.searchTerm = '';
    this.onSearch();
  }

  getInitials(value: string): string {
    if (!value) return '?';
    const parts = value.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  getDepartmentsCount(): number {
    const names = new Set(
      (this.filteredUsers || [])
        .map((u: any) => u.depData?.name)
        .filter(Boolean)
    );
    return names.size;
  }

  confirmUserDelete(event: Event, userId: number) {
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: "هل تريد تأكيد المسح؟",
      accept: () => {
        this.authService.deleteUser(userId).subscribe(() => {
          this.users = this.users.filter(x => x.id != userId);
          this.filteredUsers = this.filteredUsers.filter(x => x.id != userId);
          this.toastr.success("تمت المسح ", "عملية ناجحة");
          this.closeDeleteUserModal();
        }, (err) => {
          this.toastr.error("فشل المسح ", "فشل");
        })
      },
      reject: () => {
        this.toastr.info("تم الالغاء", "الغاء");
      }
    });
  }
  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }
  openUserModal(userId: number) {
    if (userId > 0) {
      const user = structuredClone(this.users.find(user => {
        return user.id == userId
      }))
      this.selectedUser = user as SignUpModel;
      this.selectedUser.section_id = this.selectedUser.sectionData?.id || 0;
      this.selectedUser.department_id = this.selectedUser.depData?.id || 0;
      console.log("this.selectedUser.section_id ", this.selectedUser.section_id);
      if (this.selectedUser.department_id) {
        const dep = structuredClone(this.departments.find(dep => dep.id == this.selectedUser.depData?.id) as DepData);
        this.deps_Sections = dep.sections as SectionData[];
      }
      this.roleChange();
    } else {
      this.selectedUser = {} as SignUpModel;
    }
    this.isModalVisible = true;
  }
  closeUserModal() {
    this.isModalVisible = false;
    this.userForm.reset({});
    this.passwordFieldType = 'password'
  }
  submit() {
    if (!this.selectedUser.id && this.userForm.valid) {
      this.authService.signup(this.userForm.value as any).subscribe((response: any) => {
        this.toastr.success("تم إضافة المستخدم بنجاح", "نجاح");
        const { id, depData, sectionData, roleData } = response['data']['user'];
        const {
          role,
          username,
          name,
          email,
          job_title,
          department_id,
          section_id
        } = this.userForm.value;
        console.log("user", this.userForm.value);
        this.users.push({
          id,
          role,
          username,
          name,
          email,
          job_title,
          department_id,
          section_id,
          depData,
          sectionData,
          roleData
        } as any);
        this.userForm.reset({});
        this.selectedDepId = 0;
        this.deps_Sections = [];
        this.isModalVisible = false;
      })
    } else if (this.selectedUser.id > 0 && this.userForm.valid) {
      const {
        role,
        username,
        name,
        email,
        job_title,
        department_id,
        section_id
      } = this.selectedUser;

      const model = {
        role,
        username,
        name,
        email,
        job_title,
        department_id,
        section_id
      };
      this.authService.updateUser(this.selectedUser.id, model).subscribe((response: any) => {
        this.toastr.success("نجح تحديث المستخدم", "نجاح")
        const updatedUser = response['data']['user'];
        this.users = this.users.map((user) => {
          if (user.id == this.selectedUser.id) {
            return { ...user, ...model, ...updatedUser }
          } else {
            return user
          }
        });
        this.filteredUsers = this.filteredUsers.map((user) => {
          if (user.id == this.selectedUser.id) {
            return { ...user, ...model, ...updatedUser }
          } else {
            return user
          }
        });

        this.selectedUser = {} as SignUpModel;
        this.selectedDepId = 0;
        this.isModalVisible = false;
      })
    } else {
      this.toastr.error(this.dir == 'rtl' ? "يرجي مراجعةالبيانات" : "Please review the information")
    }
  }
  openPasswordModal(userId: number) {
    this.isPasswordModalVisible = true;
    this.selectedUserPasswordId = userId;
  }
  closePasswordModal() {
    this.isPasswordModalVisible = false;
    this.passwordForm.reset({});
    this.passwordFieldType = 'password'
  }
  depChange() {
    const dep = this.departments.find(dep => dep.id.toString() == this.selectedUser.department_id.toString()) as DepData;
    this.deps_Sections = dep.sections as SectionData[];
  }
  filterByRole() {
    if (this.selectedPermission && this.selectedPermission !== 'all') {
      const filterdUsers = this.users.filter(user => {
        return user.role == this.selectedPermission
      })
      this.filteredUsers = structuredClone(filterdUsers)
    } else {
      this.filteredUsers = this.users;
    }
  }
  submitPassword() {
    this.authService.changePassword(this.selectedUserPasswordId, this.passwordForm.value as { password: string }).subscribe(() => {
      this.toastr.success("نجح تحديث كلمة مرور المستخدم", "نجاح")
      this.passwordForm.reset({})
      this.closePasswordModal();
    })
  }
  showSectionDropdown = false;
  roleChange() {
    this.showSectionDropdown = true;
    const selectedRole = this.userForm.get('role')?.value;
    this.Sec_Dep_Disabled = false;

    const sectionControl = this.userForm.get('section_id');
    const departmentControl = this.userForm.get('department_id');

    if (selectedRole === 'department_admin') {
      sectionControl?.setValue(null);
      this.showSectionDropdown = false;
      sectionControl?.clearValidators();
      departmentControl?.setValidators(Validators.required);
    } else if (selectedRole === 'admin') {
      // For admin, neither department nor section is required
      sectionControl?.setValue(null);
      departmentControl?.setValue(null);
      sectionControl?.clearValidators();
      departmentControl?.clearValidators();
      this.showSectionDropdown = false;
    } else {
      // For other roles, both are required
      sectionControl?.setValidators(Validators.required);
      departmentControl?.setValidators(Validators.required);
    }

    sectionControl?.updateValueAndValidity();
    departmentControl?.updateValueAndValidity();
  }
  isDepartmentAdmin(): boolean {
    return this.userForm.get('role')?.value === 'department_admin';
  }
  isAdmin(): boolean {
    return this.userForm.get('role')?.value === 'admin';
  }
  togglePasswordVisibility(event: Event): void {
    event.preventDefault();
    if (this.passwordFieldType === 'password') {
      this.passwordFieldType = 'text';
      this.passwordIconClass = 'fa fa-eye';
    } else {
      this.passwordFieldType = 'password';
      this.passwordIconClass = 'fa fa-eye-slash';
    }
  }


  openDeleteUserModal(userId: number) {
    this.isDeleteUserModal = true;
    this.selectedUserId = userId;
    this.adminService.getUserDeletionPreview(userId).subscribe((response: any) => {
      this.currentUserDeletionPreview = response['data'];

      this.UserIndicators = Object.values(this.currentUserDeletionPreview['strategiesWithIndicators']).reduce((acc: any[], curr: any) => {
        const mapped = curr.indicators.map((x: any) => {
          return {
            "strategy_name": curr.strategy_name,
            ...x,
            filteredInChargeExecutives: x.inChargeExecutives,
          }
        })
        return [...acc, ...mapped]
      },
        [] as any[]
      )
      const groupIndicatorControls = {} as any;
      this.UserIndicators.forEach((indicator, index) => {
        groupIndicatorControls[index] = new FormGroup({
          indicator_id: new FormControl(indicator.id),
          in_charge_id: new FormControl('', Validators.required),
        });
      });
      this.userIndicatorForm = new FormGroup(groupIndicatorControls);
      // ==================================
      this.isProjectDeletable = !this.UserIndicators.length;

      this.UserProjects = Object.values(this.currentUserDeletionPreview['strategiesWithProjects']).reduce((acc: any[], curr: any) => {
        const mapped = curr.projects.map((x: any) => {
          return {
            "strategy_name": curr.strategy_name,
            ...x,
            filteredInChargeExecutives: x.inChargeExecutives,
          }
        })
        return [...acc, ...mapped]
      },
        [] as any[]
      )
      const groupProjectControls = {} as any;
      this.UserProjects.forEach((project, index) => {
        groupProjectControls[index] = new FormGroup({
          project_id: new FormControl(project.id),
          executive_in_charge_id: new FormControl('', Validators.required),
          entity_in_charge_id: new FormControl('', Validators.required),
          entity_in_charge_type: new FormControl(project, Validators.required),
        });


        groupProjectControls[index].get('entity_in_charge_id')
          ?.valueChanges.subscribe((entityInchargeValue: string) => {
            console.log('entityInchargeValue', entityInchargeValue);
            if (typeof entityInchargeValue === 'number') return;
            const [entity_in_charge_type, entity_in_charge_id] = entityInchargeValue?.split('-')
            const formGroup = this.userProjectsForm.get(String(index)) as FormGroup;
            const entity_in_charge_id_control = formGroup.get('entity_in_charge_id') as FormControl;
            const entity_in_charge_type_control = formGroup.get('entity_in_charge_type') as FormControl;
            entity_in_charge_id_control.setValue(+entity_in_charge_id);
            entity_in_charge_type_control.setValue(entity_in_charge_type);

            const unitEmployees = this.currentUserDeletionPreview.unitEmployeesMap[entityInchargeValue]
            console.log('unitEmployees', unitEmployees);
            this.UserProjects[index].filteredInChargeExecutives = this.UserProjects[index].inChargeExecutives.filter((x: any) => unitEmployees.includes(x.id))
          });
      });
      this.userProjectsForm = new FormGroup(groupProjectControls);
    });

  }
  closeDeleteUserModal() {
    this.isDeleteUserModal = false;
  }
  onIndiactorTransferSubmit() {
    console.log(this.userIndicatorForm.value);
    this.adminService.transferIndicators(this.selectedUserId, { "indicators": Object.values(this.userIndicatorForm.value) }).subscribe((response: any) => {
      this.toastr.success("تم التحويل بنجاح")
      this.UserIndicators = [];
      this.toastr.success(response['data']['message'])
    })
  }
  onProjectTransferSubmit() {

    console.log(this.userProjectsForm.value);
    this.adminService.TransferUserProjects(this.selectedUserId, { "projects": Object.values(this.userProjectsForm.value) }).subscribe((response: any) => {
      this.toastr.success("تم التحويل بنجاح")
      this.UserProjects = [];
      this.toastr.success(response['data']['message'])
    })
  }

  pageNumber = 0;
  page_size = 10;
  paginator = {} as IPaginator;
  pageChangeHandler(page: number) {
    this.pageNumber = page;
    this.fetchUsers();
  }
  pageSizeChangeHandler(pageSize: number) {
    this.page_size = pageSize;
    this.fetchUsers();
  }

  setSelectedPermission(value: any) {
    this.selectedPermission = value;
    this.fetchUsers();
  }
  
  onRoleChange() {
    this.fetchUsers();
  }
  
  toggleMenu(event: Event, userId: number) {
    event.stopPropagation();
    this.activeMenuId = this.activeMenuId === userId ? null : userId;
  }

  closeMenu() {
    this.activeMenuId = null;
  }

  closeAllMenus() {
    this.activeMenuId = null;
  }
}
